import styled from 'styled-components';

const FullImage = styled.img`
  width: 100%;
  display: block;
`;

export default FullImage;
